<template>
  <button type="button" class="button" @click="$emit('click')">
    <span class="protein" v-if="!this.hidden"></span>
    <span class="protein" v-else></span>
  </button>
</template>

<script>
export default {
  props: {
    hidden: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.protein {
  font-family: "EBI-Common";
  font-size: 20px;
}
.button {
  background: grey;
  color: white;
  font-size: 15px;
}
</style>